if (!customElements.get('epic-together')) {
  customElements.define('epic-together', class EpicTogether extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.productInfo = this.closest('product-info');
      this.form = this.querySelector('[data-together-form]');
      this.button = this.querySelector('[data-together-submit]');
      this.status = this.querySelector('[data-together-status]');
      this.main = JSON.parse(this.querySelector('[data-together-main-state]').textContent);
      this.rows = [...this.querySelectorAll('[data-together-item]')];
      this.onChange = () => this.render();
      this.onSubmit = (event) => this.submit(event);
      this.form.addEventListener('submit', this.onSubmit);
      this.productInfo.addEventListener('change', this.onChange);
      this.productInfo.addEventListener('input', this.onChange);
      this.unsubscribers = [];
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
          if (!this.productInfo.contains(data.event.target)) return;
          this.pending = true;
          this.render();
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.section) return;
          const source = data.html.querySelector('[data-together-main-state]');
          if (source) this.main = JSON.parse(source.textContent);
          this.pending = false;
          this.render();
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.cartUpdate, () => queueMicrotask(() => this.render())));
      }
      const bundle = this.productInfo.querySelector('epic-bundle-selector');
      if (bundle) {
        this.observer = new MutationObserver(() => this.render());
        this.observer.observe(bundle, { attributes: true, attributeFilter: ['aria-busy'] });
      }
      this.render();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.productInfo?.removeEventListener('change', this.onChange);
      this.productInfo?.removeEventListener('input', this.onChange);
      this.unsubscribers?.forEach(fn => fn());
      this.observer?.disconnect();
      this.initialized = false;
    }
    money(amount) {
      return new Intl.NumberFormat('en-IN', { style:'currency', currency:this.dataset.currency || 'INR', minimumFractionDigits:amount % 100 === 0 ? 0 : 2, maximumFractionDigits:2 }).format(amount / 100);
    }
    selection() {
      const bundle = this.productInfo.querySelector('epic-bundle-selector');
      const quantityInput = this.productInfo.querySelector('.quantity__input');
      const quantity = Number(bundle?.querySelector('input:checked')?.value || quantityInput?.value || 1);
      const state = bundle?.state;
      const mainId = Number(document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value);
      const offer = state ? bundle.constructor.offer(quantity, state) : { total:this.main.price * quantity };
      const withinRules = state ? bundle.constructor.canSelect(quantity, state) : (!quantityInput || quantityInput.checkValidity());
      const valid = !this.pending && !bundle?.pending && mainId === Number(this.main.id) && this.main.available && Number.isInteger(quantity) && quantity > 0 && withinRules;
      const extras = this.rows.filter(row => row.querySelector('input[type="checkbox"]').checked).map(row => {
        const option = row.querySelector('select').selectedOptions[0];
        return { id:Number(option.value), quantity:1, price:Number(option.dataset.price), available:!option.disabled };
      });
      return { quantity, mainId, mainTotal:offer.total, total:offer.total + extras.reduce((sum,item) => sum + item.price,0), extras, valid:valid && extras.every(item=>item.available) };
    }
    render() {
      const selected = this.selection();
      this.querySelector('[data-together-main-id]').value = selected.mainId || '';
      this.querySelector('[data-together-main-quantity]').value = selected.quantity;
      const variantLabel = this.main.title === 'Default Title' ? '' : `${this.main.title} · `;
      this.querySelector('[data-together-main-title]').textContent = `${variantLabel}Qty ${selected.quantity}`;
      this.querySelector('[data-together-main-price]').textContent = this.money(selected.mainTotal);
      const mainImage = this.querySelector('.epic-together__item--main img');
      if (mainImage && mainImage.getAttribute('src') !== this.main.image) { mainImage.removeAttribute('srcset'); mainImage.src = this.main.image; }
      this.rows.forEach(row => {
        const option = row.querySelector('select').selectedOptions[0];
        row.querySelector('[data-together-item-price]').textContent = this.money(Number(option.dataset.price));
        const img = row.querySelector('img');
        if (img && img.getAttribute('src') !== option.dataset.image) { img.removeAttribute('srcset'); img.src = option.dataset.image; }
        row.querySelector('select').disabled = Boolean(this.busy);
        row.querySelector('input[type="checkbox"]').disabled = Boolean(this.busy);
      });
      this.querySelector('[data-together-total]').textContent = this.money(selected.total);
      const count = selected.quantity + selected.extras.length;
      this.querySelector('[data-together-count]').textContent = `${count} ${count === 1 ? 'item' : 'items'} selected`;
      this.button.disabled = Boolean(this.busy) || !selected.valid || selected.extras.length === 0;
      this.button.setAttribute('aria-busy', this.busy ? 'true' : 'false');
      this.button.innerHTML = this.busy ? 'Adding…' : `Add ${count} selected items to cart <span aria-hidden="true">+</span>`;
      if (!this.busy && !selected.extras.length) this.status.textContent = 'Select a companion product to add together.';
      else if (!this.busy && this.status.textContent === 'Select a companion product to add together.') this.status.textContent = '';
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy) return;
      const selected = this.selection();
      if (!selected.valid || !selected.extras.length) { this.render(); return; }
      this.busy = true;
      this.status.textContent = '';
      this.render();
      const cart = document.querySelector('cart-drawer');
      const items = [{ id:selected.mainId, quantity:selected.quantity }, ...selected.extras.map(({ id,quantity })=>({ id,quantity }))];
      const body = { items };
      if (cart) {
        body.sections = cart.getSectionsToRender().map(section=>section.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement(this.button);
      }
      let response;
      try {
        const result = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, credentials:'same-origin', body:JSON.stringify(body) });
        response = await result.json();
        if (!result.ok || response.status) throw new Error(response.description || 'These items could not be added. Please check availability and try again.');
      } catch (error) {
        this.status.textContent = error.message || 'Could not add the selected items. Please try again.';
        this.busy = false;
        this.render();
        return;
      }
      // A cart-render failure must never retry a successful add request.
      this.status.textContent = 'Selected items added to your cart.';
      this.busy = false;
      this.render();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source:'epic-together', productVariantId:selected.mainId, cartData:response });
      if (cart && body.sections.every(id=>response.sections?.[id])) {
        try { cart.classList.remove('is-empty'); cart.renderContents(response); }
        catch { window.location.assign(window.routes?.cart_url || '/cart'); }
      } else window.location.assign(window.routes?.cart_url || '/cart');
    }
  });
}
